import { combineReducers } from '@reduxjs/toolkit';
import checkoutSaga from '@state/features/checkout.saga';
import checkoutSlice from '@state/features/checkout.slice';
import { all, fork } from 'redux-saga/effects';
import accordionStepsSaga from './accordion.saga';
import accordionstepsSlice from './accordion.slice';
export const checkoutRootReducer = combineReducers({
    checkout: checkoutSlice.reducer,
    step: accordionstepsSlice.reducer,
});
export function* checkoutRootSaga() {
    yield all([fork(checkoutSaga), fork(accordionStepsSaga)]);
}
